import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { SwiperModule } from 'swiper/angular';
import { AppbarComponent } from '@app/layout/components/appbar/appbar.component';
import { CheckboxItemComponent } from '@shared/components/checkbox-item/checkbox-item.component';
import { DashboardPage } from './dashboard.page';
import { DashboardService } from './services/dashboard.service';
import { DashboardPageRoutingModule } from './dashboard-routing.module';
import { ChartsService } from './services/charts.service';
import { PipesModule } from '@app/shared/pipes';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DashboardPageRoutingModule,
    SwiperModule,
    ReactiveFormsModule,
    AppbarComponent,
    CheckboxItemComponent,
    PipesModule,
    AngularFirestoreModule
  ],
  declarations: [DashboardPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [DashboardService, ChartsService],
})
export class DashboardPageModule {}
